RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    apps.Share = window.createMarionetteApp();
    apps.Share.name = 'Share';

    apps.Share.addRegions({
        mainRegion: '.x-main-region'
    });

});
